import { fetchContactAuth } from './contactAuth'
import {
  clearContactAuthStorage,
  readStoredContactAuth,
} from './contactAuthTokenStorage'

export type ShellContactAuthResult =
  | {
      kind: 'ready'
      smartAuth: string
      jwtPayload: Record<string, unknown> | null
      jwtPreview: string
    }
  | { kind: 'expired'; jwtPayload: Record<string, unknown> | null }
  | { kind: 'auth-failed'; status: number; message: string }
  | { kind: 'error'; message: string }

export async function resolveShellContactAuth(token: string): Promise<ShellContactAuthResult> {
  const trimmed = token.trim()
  const stored = readStoredContactAuth(trimmed)

  if (stored.kind === 'ready') {
    return {
      kind: 'ready',
      smartAuth: stored.smartAuth,
      jwtPayload: stored.jwtPayload,
      jwtPreview: stored.jwtPreview,
    }
  }

  if (stored.kind === 'expired') {
    const jwtPayload = stored.jwtPayload
    clearContactAuthStorage()
    return { kind: 'expired', jwtPayload }
  }

  const auth = await fetchContactAuth(trimmed)
  if (auth.kind === 'error') {
    if (auth.status === 401 || auth.status === 404 || auth.status === 410) {
      clearContactAuthStorage()
      return { kind: 'auth-failed', status: auth.status, message: auth.message }
    }
    return { kind: 'error', message: auth.message }
  }

  return {
    kind: 'ready',
    smartAuth: auth.smartAuth,
    jwtPayload: auth.jwtPayload,
    jwtPreview: auth.jwtPreview,
  }
}
